import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { serverStore } from '../../stores/server.store';
import { SteamDashboard } from './SteamDashboard';
import { MinecraftDashboard } from './MinecraftDashboard';

/**
 * Server-Übersicht: Steam-Server und Minecraft-Server haben je eine eigene
 * Übersicht in derselben Sprache (Entwurf „A · Spielbühne", 2026-09-14).
 * Einstellungen haben ihre eigene Sektion; hier nur die Schnelleinstellungen.
 */
export const ServerDashboard = observer(() => {
  const { activeServer } = serverStore;

  // Aktivität/Log mit dem Verlauf aus logs/latest.log füllen - sonst zeigt die
  // Übersicht nach dem Seitenaufruf nur Zeilen, die ab JETZT per Socket kommen.
  useEffect(() => {
    if (activeServer?.id) serverStore.fetchServerLogHistory(activeServer.id);
  }, [activeServer?.id]);

  if (!activeServer) return null;
  return String(activeServer.type || '').startsWith('steam') ? <SteamDashboard /> : <MinecraftDashboard />;
});
